import mockImg from "@assets/img/mock3.png";
import mockMain from "@assets/icons/marketIntelligence/Photo.png";

export const data = {
  item: {
    imgs_gallery: [
      mockMain,
      mockImg,
      mockImg,
      mockImg,
      mockImg,
      mockImg,
      mockImg,
      mockImg,
      mockImg,
    ],
    video_gallery: [
      {
        src: mockImg,
        title:
          "Sugarbear Pro Hair Vitamins - Vegan Gummies for Luscious Hair and Nails",
      },
      {
        src: mockImg,
        title:
          "Sugarbear Pro Hair Vitamins - Vegan Gummies for Luscious Hair and Nails",
      },
      {
        src: mockImg,
        title: "Sugarbear Hair - Helps Maintain Beautiful Hair and Nails",
      },
    ],
    title:
      "Sugarbear Vegan Hair Gummy Vitamins with Biotin, Vitamin C, Vitamin B-12, Zinc for Hair Skin & Nails (1 Month Supply)",
    bullets: [
      "We designed our vitamins for those who were looking for easy to eat vitamins without the struggle of swallowing pills. Nourish your hair from within with our cruelty free gummy bear hair vitamins.*",
      "Scientifically formulated blend of Biotin, Vitamin D, Vitamin E, Vitamin B6, Folate, Calcium, Zinc, Sodium, Iodine and our hair proprietary blend with Inositol.",
      "This certified vegan formula is based on clinical trials that have shown nutrients play an important role in hair health.* No gelatin. No dairy. No gluten. Kosher and Halal Certified. 100 Day Money Back Guarantee with proof of purchase.",
      "Gluten free, gelatin free, dairy free, soy free, nut free, egg free, and wheat free",
      "100 Day Money Back Guarantee with proof of purchase.",
    ],
    terms: [
      "Sugarbear sugar bear hair vitamins minerals loss hairs nails pills vegan.",
    ],
  },
  barrels: {
    listing_value: 45,
    photo_value: 60,
    video_value: 15,
    content_value: null,
  },
};
